import { SxProps, Theme } from "@mui/material/styles";
import { UseMaterialColors } from "lib/hooks";

export const ContainmentCardStyle = (): SxProps<Theme> => {
    const materialColors = UseMaterialColors()

    return {
        position: "relative",
        borderRadius: 0,
        p: 2,
        mb: 2,
        boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
        backgroundColor: materialColors.surfaceContainer,
    }
}